import { merge, Stack, Text } from '@fluentui/react';
import React, { useMemo } from 'react';
import { useIntervenants } from '../../../contexts/intervenantContext';
import { useLotsCommerciaux } from '../../../contexts/lotCommercialContext';
import { ResponsiveSize, useResponsiveSize } from '../../../contexts/responsiveContext';
import Page from '../../Page';
import Interlocutor from './Interlocutor';
import SummaryMonLogement from './SummaryMonLogement';
import TableLots from './TableLots';

const MonLogement = () => {

    // CONTEXTS
    const { lotCommercialActif } = useLotsCommerciaux();
    const { adresse, cp, lotType, nomCommercial, numero, prixTTC, tva, ville } = lotCommercialActif || {};
    const { intervenants } = useIntervenants();
    const { responsiveSize } = useResponsiveSize();

    // MEMOS
    const _chargeeDeRelationClient = useMemo(() => {
        return intervenants.find(intervenant => intervenant.type === "chargeeDeRelationClient") || {};
    }, [intervenants]);

    const _notaireClient = useMemo(() => {
        return intervenants.find(intervenant => intervenant.type === "notaireClient") || {};
    }, [intervenants]);

    const _notaireOperation = useMemo(() => {
        return intervenants.find(intervenant => intervenant.type === "notaireOperation") || {};
    }, [intervenants]);

    const _styles = useMemo(
        () => {
            let styles = {
                interlocutors: { root: { gap: 4 } },
                title: {
                    root: {
                        fontSize: 16,
                        fontWeight: 700,
                        lineHeight: "19px",
                        marginBottom: 12,
                        marginTop: 26,
                    }
                },
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        interlocutors: {
                            root: {
                                flexDirection: "row",
                                flexWrap: "wrap"
                            }
                        },
                        title: { root: { marginTop: 52 } },
                    }
                );

            return styles;
        },
        [responsiveSize]
    );

    // RENDER
    return <Page title="Mon logement">

        <SummaryMonLogement
            adresse={adresse}
            cp={cp}
            lotType={lotType}
            nomCommercial={nomCommercial}
            numero={numero}
            prixTTC={prixTTC}
            tva={tva}
            ville={ville}
        />

        <Text styles={_styles.title}>Votre bien se compose de :</Text>

        <TableLots />

        {
            intervenants.every(intervenant => !intervenant.nom && !intervenant.prenom && !intervenant.tel && !intervenant.portable && !intervenant.email)
                ? null
                : <>
                    <Text styles={_styles.title}>Vos interlocuteurs</Text>
                    <Stack styles={_styles.interlocutors}>
                        <Interlocutor {..._notaireClient} label="Votre notaire" />
                        <Interlocutor {..._notaireOperation} label="Notaire de l'opération" />
                        <Interlocutor {..._chargeeDeRelationClient} label="Chargé(e) de relation client" />
                    </Stack>
                </>
        }

    </Page>;

};

export default MonLogement;